import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IStaffProfileType } from "./routeType";

const { key, getPath } = getApi("types.staffProfileType.getAll");

type IExtractedRouteType =
  IStaffProfileType["StaffProfileTypeCollectionRetrieve"];

export type IGetStaffProfileType = IPickCollectionQuery<IExtractedRouteType>;

const getStaffProfileType: Fetcher<
  IGetStaffProfileType["response"],
  IGetStaffProfileType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetStaffProfileType = createQuery({
  queryKey: [key],
  fetcher: getStaffProfileType,
});
